import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from './core/services/loader.service';

@Component({
    selector: 'app-root',
    template: `
        <app-full-screen-loader></app-full-screen-loader>
        <router-outlet></router-outlet>
    `,
})
export class AppComponent implements OnInit {
    constructor(private translate: TranslateService, private loaderService: LoaderService) {
        this.translate.addLangs(['pt-BR', 'en']);
        this.translate.setDefaultLang('pt-BR');
        this.translate.use('pt-BR');

        this.loaderService.setAppLoading(true);
    }
    ngOnInit() {
        console.log(document.getElementById('server-host')?.getAttribute('value'));
    }
}
